module.exports = __webpack_public_path__ + "img/list.da673d58.png";